import { useEffect, useState } from 'react';

export const getResponsiveBreakpoint = width => {
  if (width <= 640) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
};

export const useResponsiveBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => getResponsiveBreakpoint(window.innerWidth));

  useEffect(() => {
    const updateBreakpoint = () => setBreakpoint(getResponsiveBreakpoint(window.innerWidth));
    window.addEventListener('resize', updateBreakpoint);
    return () => window.removeEventListener('resize', updateBreakpoint);
  }, []);

  return breakpoint;
};

export const getSectionStylesForBreakpoint = (section, breakpoint) => {
  const styles = section?.styles || {};
  const responsive = section?.responsiveStyles?.[breakpoint] || {};
  const targets = new Set([...Object.keys(styles), ...Object.keys(responsive)]);
  return Object.fromEntries([...targets].map(target => [
    target,
    { ...(styles[target] || {}), ...(responsive[target] || {}) },
  ]));
};
